import { ImageLinkSlider } from '../../__utils/sliders';

const $ = jQuery.noConflict();

// Calculates position of center slide and margin of slider pagination
const calculateSliderElementsPosition = (slider, sliderSelector) => {
    const slideList = slider.querySelector('.slick-track');
    const sliderPrev = slider.querySelector('.slick-prev');
    const sliderNext = slider.querySelector('.slick-next');

    slideList.style.left = '';

    slider.classList.add('no-trans');

    const sliderDots = slider.querySelector('.slick-dots');
    const activeSlide = slider.querySelector('.slick-active');
    const activeSlideLeft = activeSlide.getBoundingClientRect().left;
    const activeSlideFrame = activeSlide.querySelector('.block-image-link-slider__slide-frame');
    const container = document.querySelector('.container');
    const containerStyle = getComputedStyle(container);
    const containerPaddingLeft = parseFloat(containerStyle.paddingLeft.replace('px', ''));
    const containerLeft = parseFloat(container.getBoundingClientRect().left + containerPaddingLeft);
    const containerRight = parseFloat(container.getBoundingClientRect().left + (container.offsetWidth - containerPaddingLeft));
    const slideListLeft = activeSlideLeft - containerLeft;

    slideList.style.left = -slideListLeft + 'px';
    sliderDots.style.marginLeft = containerLeft + 'px';

    const currActiveSlideLeft = activeSlide.getBoundingClientRect().left
    if(currActiveSlideLeft < containerPaddingLeft) {
        slideList.style.left = -(activeSlideLeft) + 'px';
    }

    sliderNext.style.right = 'auto';
    sliderNext.style.left = containerRight + 'px';
    sliderNext.style.top = activeSlide.offsetHeight / 2 + 'px';

    if(containerRight + sliderNext.offsetWidth > document.body.offsetWidth) {
        sliderNext.style.right = '0';
        sliderNext.style.left = 'auto';
    }

    const activeSlideFrameLeft = activeSlideFrame.getBoundingClientRect().left;
    sliderPrev.style.top = activeSlide.offsetHeight / 2 + 'px';
    sliderPrev.style.left = (activeSlideFrameLeft - sliderPrev.offsetWidth) + 'px';

    if(activeSlideFrameLeft - sliderPrev.offsetWidth <= 0) {
        sliderPrev.style.left = '0';
    }

    $(sliderSelector).slick('setPosition');
    slider.classList.remove('no-trans');
}

const paginationDraggable = (sliderSelector) => {
	let paginationDrag = false;
	let cursorPosition = 0;
	let activeDragRail = null;
	let activeDragEl = null;
	let activeDragElLeft = 0;
	let activeDragButtons = null;

	const paginations = document.querySelectorAll(sliderSelector + ' .slick-dots');

	for (let i = 0; i < paginations.length; i++) {
		const element = paginations[i];
		element.classList.add('draggable-enabled');
		const paginationButtons = element.querySelectorAll('button');
		const draggableWidth = element.querySelector('li').offsetWidth;
		const dragElHtml = '<li class="draggable-rail"><button class="draggable-button" style="width: '+draggableWidth+'px;" aria-label="Draggable Rail"></button></li>';

		element.insertAdjacentHTML('beforeend', dragElHtml);

		const dragRail = element.querySelector('.draggable-rail');
		const dragEl = element.querySelector('.draggable-button');

		dragRail.addEventListener('mousedown', (e) => {
			const dragRaiLeft = dragRail.getBoundingClientRect().left;
			cursorPosition = e.clientX - dragRaiLeft;
			paginationDrag = true;
			activeDragRail = dragRail;
			activeDragEl = dragEl;
			activeDragButtons = paginationButtons;

			for (let y = 0; y < paginationButtons.length; y++) {
				const button = paginationButtons[y];
				const buttonParent = button.parentNode;
				const buttonLeft = buttonParent.offsetLeft;
				const buttonRight = buttonLeft + buttonParent.offsetWidth;

				if(cursorPosition >= buttonLeft && cursorPosition <= buttonRight) {
					const dragElPos = buttonLeft;
					dragEl.style.left = dragElPos + 'px';
					activeDragElLeft = dragElPos;

					if(!buttonParent.classList.contains('slick-active')) {
						button.click();
					}
				}
			}
		});

		window.addEventListener('resize', () => {
			const draggableWidth = element.querySelector('li').offsetWidth;
			const draggableResizeOffset = element.querySelector('li.slick-active').offsetLeft;
			dragEl.style.width = draggableWidth + 'px';
			dragEl.style.left = draggableResizeOffset + 'px';
		});
	}

	document.addEventListener('mousemove', (e) => {
		if(paginationDrag && activeDragEl !== null && activeDragButtons !== null) {
			const railLeft = activeDragRail.getBoundingClientRect().left;
			const newCursorPosition = e.clientX - railLeft;
			const railWidth = activeDragRail.offsetWidth;
			const dragRatio = Math.abs(newCursorPosition - cursorPosition);

			activeDragEl.classList.add('dragged');
			let dragDirection;

			// Drag left
			if(newCursorPosition < cursorPosition) {
				dragDirection = 'left';

				activeDragElLeft = activeDragElLeft - dragRatio;

				if(activeDragElLeft < 0) {
					activeDragElLeft = 0;
				}

				activeDragEl.style.left = activeDragElLeft + 'px';

				cursorPosition = newCursorPosition;
			}

			// Drag right
			if(newCursorPosition > cursorPosition) {
				dragDirection = 'right';

				const maxRightPos = railWidth - activeDragEl.offsetWidth;
				activeDragElLeft = activeDragElLeft + dragRatio;

				if(activeDragElLeft > maxRightPos) {
					activeDragElLeft = maxRightPos;
				}

				activeDragEl.style.left = activeDragElLeft + 'px';

				cursorPosition = newCursorPosition;
			}

			for (let i = 0; i < activeDragButtons.length; i++) {
				const element = activeDragButtons[i];
				const elementWidth = element.offsetWidth;
				const elementParent = element.parentNode;
				const elementLeft = elementParent.offsetLeft;
				const elementRight = elementLeft + elementParent.offsetWidth;

				if(dragDirection === 'left') {
					if(activeDragElLeft - dragRatio <= elementLeft && ((activeDragElLeft + elementWidth) + dragRatio) >= elementRight && !elementParent.classList.contains('slick-active')) {
						element.click();
					}
				}

				if(dragDirection === 'right') {
					if(activeDragElLeft + dragRatio >= elementLeft && ((activeDragElLeft + elementWidth) - dragRatio) <= elementRight && !elementParent.classList.contains('slick-active')) {
						element.click();
					}
				}
			}
		}
	});

	document.addEventListener('mouseup', () => {
		if(paginationDrag) {
			activeDragEl.classList.remove('dragged');
			paginationDrag = false;
			activeDragEl = null;
			activeDragButtons = null;
		}
	});
}

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        ImageLinkSlider.init();

        $(ImageLinkSlider.selector).on('beforeChange', function(e, slick, currentSlide, nextSlide) {
            const slideCount = slick.slideCount - 1;
            const nextSlideIsFirst = currentSlide === slideCount;
            const nextSlideIsLast  = nextSlide === slideCount;
            const $activeSlide = $(slick.$slider[0]).find('.slick-active');
            const decl = currentSlide - nextSlide;
            let direction = null;

            if(decl == 1 || decl == (slideCount)*(-1) ) {
                direction = 'prev';
            } else {
                direction = 'next';
            }

            if (nextSlideIsFirst && direction === 'next') {
                $activeSlide.next('.slick-slide').addClass('slick-clone-current');
            }
            if (nextSlideIsLast && direction === 'prev') {
                $activeSlide.prev('.slick-slide').addClass('slick-clone-current');
            }
        });

        // Remove your custom active class active slide finished
        $(ImageLinkSlider.selector).on('afterChange', function(e, slick, currentSlide, nextSlide) {
            const cloneCurrent = $(slick.$slider[0]).find('.slick-clone-current');
            cloneCurrent.removeClass('slick-clone-current');
        });

		// Move draggable pagination element before slide change
		$(ImageLinkSlider.selector).on('beforeChange', function(e, slick, currentSlide, nextSlide) {
			const paginationItems = $(slick.$slider[0]).find('.slick-dots li:not(.draggable-rail)');
			const draggableEl = $(slick.$slider[0]).find('.slick-dots .draggable-button');
			const nextItemLeft = $(paginationItems[nextSlide]).position().left;
			$(draggableEl).css('left', nextItemLeft + 'px');
		});
    },
    loaded() {
        const sliders = document.querySelectorAll(ImageLinkSlider.selector);

        for (let i = 0; i < sliders.length; i++) {
            const element = sliders[i];
            calculateSliderElementsPosition(element, ImageLinkSlider.selector);
        }

		paginationDraggable(ImageLinkSlider.selector);

    },
    resized() {
        const sliders = document.querySelectorAll(ImageLinkSlider.selector);

        for (let i = 0; i < sliders.length; i++) {
            const element = sliders[i];
            calculateSliderElementsPosition(element, ImageLinkSlider.selector);

            setTimeout(() => {
                calculateSliderElementsPosition(element, ImageLinkSlider.selector);
            }, 250);
        }
    },
    scrolled() {},
    keyDown(e) {},
    scrolled() {},
    keyDown(e) {},
    mouseUp(e) {},
};
export default controller;
